"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertQuestionToAskAnAgentResult = void 0;
exports.convertQuestionToAskAnAgentResult = function (question) {
    return {
        askAuthor: question.askedBy,
        askText: question.questionText,
        askDate: question.askedDate,
        answerAuthor: question.answeredAgentName,
        answerAuthorLink: question.answeredAgentUrl,
        answerText: '',
        answerDate: question.answeredDate,
        answerPhoto: question.answeredAgentImageUrl,
        answerLink: question.questionUrl,
    };
};
